import { render, staticRenderFns } from "./UserProfileViewFollowers.vue?vue&type=template&id=617fd96a&"
import script from "./UserProfileViewFollowers.vue?vue&type=script&lang=js&"
export * from "./UserProfileViewFollowers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports